import React from "react";
import { formatCompactEuro } from "./formatters";
import styles from "./DossierDashboard.module.scss";

const KpiBand = ({ stats }) => (
  <div className={styles.sect}>
    <div className={styles.kpiGrid}>
      <div className={`${styles.kpi} ${styles.kpiHero}`}>
        <div className={styles.kpiValue}>
          {formatCompactEuro(stats.engagementTTC)} <small>TTC</small>
        </div>
        <div className={styles.kpiLabel}>
          engagement total client
          <br />
          (loyers × durées × qtés)
        </div>
      </div>
      <div className={styles.kpi}>
        <div className={styles.kpiValue}>
          {stats.count} <small>devis</small>
        </div>
        <div className={styles.kpiLabel}>{stats.vehicleCount} véhicules</div>
      </div>
      <div className={styles.kpi}>
        <div className={styles.kpiValue}>
          {formatCompactEuro(stats.monthlyRentHT)}
        </div>
        <div className={styles.kpiLabel}>loyer mensuel cumulé HT</div>
      </div>
      <div className={styles.kpi}>
        <div className={styles.kpiValue}>
          {formatCompactEuro(stats.investTotalHT)}
        </div>
        <div className={styles.kpiLabel}>investissement total HT</div>
      </div>
    </div>
  </div>
);

export default KpiBand;
